import { jsx as r } from "react/jsx-runtime";
import { SuggestionsOverlay as t } from "./style.js";
import { useSearchBarContext as i } from "../../context.js";
function a({ children: o, ...e }) {
  const { isSearchBarDropdownOpen: n } = i();
  return /* @__PURE__ */ r(t, { ...e, open: n, children: /* @__PURE__ */ r("div", { children: o }) });
}
export {
  a as Suggestions
};
